import React from 'react';
import './Team.css';

function Team(props){
  return(
    <>
       <div className="column">
          <div className="card">
            <div className="img-container">
              <img src={props.photo} alt=''/>
            </div>
            <h2 className={props.Name_cName}>{props.Name}</h2>
            <h3 className={props.Role_cName}>{props.Role}</h3>
            <h3 className={props.Major_cName}>{props.Major}</h3>
            <h3 className={props.Department_cName}>{props.Department}</h3>
            </div>
          </div>
    </>
  )
}
export default Team

